export default "__VITE_ASSET__DlRuUqb9__"